function searchStringLowerCase (str, serchStr) {
  return str.search(new RegExp(serchStr, 'i'))
}

function getComputableNumber (value) {
  let result = parseFloat(value)
  if (isNaN(result)) {
    result = 0
  }
  return result
}

function sumFloats (a, b) {
  return (getComputableNumber(a) + getComputableNumber(b))
}

function isNotNullAndNotUndefined (value) {
  return ((value !== null) && (typeof value !== 'undefined'))
}

function toLocalDateInput (value) {
  if (!value) return ''
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value)) {
    return value.slice(0, 10)
  }
  const date = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(date.getTime())) return ''
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

function todayLocalDate () {
  return toLocalDateInput(new Date())
}

function formatLocalDate (value) {
  const localDate = toLocalDateInput(value)
  if (!localDate) return ''
  const [year, month, day] = localDate.split('-')
  return `${day}/${month}/${year}`
}

export {
  searchStringLowerCase,
  getComputableNumber,
  sumFloats,
  isNotNullAndNotUndefined,
  toLocalDateInput,
  todayLocalDate,
  formatLocalDate
}
